import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button, Input, FormGroup, Label, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Models from './model.json';
import "./tables.scss";
import "./Puestos.scss";
import { httpGet, httpPost, httpPUT, httpDelete } from "../../common/petitions";
// import DataLoader from "../../components/tableData";
import useUpdateCreateAlert from '../../components/alerts';
import { useNavigate } from 'react-router-dom';

const ConfigPeriodo = () => {
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [perInicioAnios, setPerInicioAnios] = useState('');
  const [perInicioFechaIni, setPerInicioFechaIni] = useState('');
  const [perInicioFechaFin, setPerInicioFechaFin] = useState('');
  const [perFinalAnios, setPerFinalAnios] = useState('');
  const [perFinalFechaIni, setPerFinalFechaIni] = useState('');
  const [perFinalFechaFin, setPerFinalFechaFin] = useState('');
  const navigate = useNavigate();
  useUpdateCreateAlert(status, message);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const rowsData = await httpGet(`/periodo`, navigate);
      const jsonData = { columns: Models.fuel, rows: rowsData.data };
      console.log(rowsData.data.length);
      if (rowsData.data.length > 0){
        handleEdit(rowsData.data[0])
      }else{
        handleCreate()
      }
      setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // console.log( name, value);
    if (name === 'perInicioAnios') setPerInicioAnios(value);
    if (name === 'perInicioFechaIni') setPerInicioFechaIni(value);
    if (name === 'perInicioFechaFin') setPerInicioFechaFin(value);
    if (name === 'perFinalAnios') setPerFinalAnios(value);
    if (name === 'perFinalFechaIni') setPerFinalFechaIni(value);
    if (name === 'perFinalFechaFin') setPerFinalFechaFin(value);
  };

  // const parseDate = (dateString) => {
  //   const regex = /^(\d{2})[\/\-](\d{2})[\/\-](\d{4})$/;
  //   if (regex.test(dateString)) {
  //     const parts = dateString.match(regex);
  //     if (parts) {
  //       const day = parts[1];
  //       const month = parts[2];
  //       const year = parts[3];
  //       return new Date(`${year}-${month}-${day}`);
  //     }
  //   }
  //   const parsedDate = new Date(dateString);
  //   if (!isNaN(parsedDate)) {
  //     return parsedDate;
  //   }
  //   return null;
  // };

//   const formatDateToDDMMYYYY = (date) => {
//     // Ensure date is treated in local time by setting the time to midnight
//     const [ month, day,year] = date.split('-');
//     // return `${day}-${month}-${year}`;
//     return `${year}-${month}-${day}`;
// };

  const handleSubmit = async () => {
    const data = {
      perinicioanios: perInicioAnios,
      periniciofechaini: perInicioFechaIni,
      periniciofechafin: perInicioFechaFin,
      perfinalanios: perFinalAnios,
      perfinalfechaini: perFinalFechaIni,
      perfinalfechafin: perFinalFechaFin
    };
      // console.log(data);
      // console.log(isUpdate);
      try {
        if (isUpdate) {
          await httpPUT(`/periodo/${selectedItem.idunique}`, data, navigate);
        } else {
          await httpPost(`/periodo`, data, navigate);
        }
        fetchData();
        toggleModal();
      } catch (error) {
        console.error("Error submitting data:", error);
      }
  };

  const handleEdit = (item) => {

    // console.log(formatDateToYYYYMMDD(item.perfinalfechaini));
    setSelectedItem(item);
    setPerInicioAnios(item.perinicioanios || '');
    setPerInicioFechaIni(item.periniciofechaini);
    setPerInicioFechaFin(item.periniciofechafin);
    setPerFinalAnios(item.perfinalanios || '');
    setPerFinalFechaIni(item.perfinalfechaini);
    setPerFinalFechaFin(item.perfinalfechafin);
    setIsUpdate(true);
    toggleModal();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Al borrar este elemento no podrá recuperarlo?")) {
      try {
        await httpDelete(`/periodo/${id}`, navigate);
        fetchData();
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
  };

  const handleCreate = () => {
    setSelectedItem(null);
    setPerInicioAnios('');
    setPerInicioFechaIni('');
    setPerInicioFechaFin('');
    setPerFinalAnios('');
    setPerFinalFechaIni('');
    setPerFinalFechaFin('');
    setIsUpdate(false);
    toggleModal();
  };

  const generatePeriodOptions = (startYear, endYear) => {
    const options = [];
    for (let year = startYear; year < endYear; year++) {
      const start = year.toString().slice(-2);
      const end = (year + 1).toString().slice(-2);
      options.push(`${start}/${end}`);
    }
    return options;
  };

  const periodOptions = generatePeriodOptions(2022, 2026);

  document.title = "Configurar - Periodo - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Configurar" title="Periodo" />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <Button color="primary" onClick={handleCreate}>Agregar Periodo</Button> */}
                  <Row>
            <Col className="col-4">
              <FormGroup>
                <Label for="perInicioAnios">Periodo Inicio</Label>
                <select className="form-control" name="perInicioAnios" id="perInicioAnios" value={perInicioAnios} onChange={handleInputChange}>
                    <option value="">--Seleccionar--</option>
                  {periodOptions.map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="perInicioFechaIni">Del</Label>
                <Input type="date" name="perInicioFechaIni" id="perInicioFechaIni" value={perInicioFechaIni} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="perInicioFechaFin">al</Label>
                <Input type="date" name="perInicioFechaFin" id="perInicioFechaFin" value={perInicioFechaFin} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <hr></hr>
            <Col className="col-4">
              <FormGroup>
                <Label for="perFinalAnios">Periodo Final</Label>
                <select className="form-control" name="perFinalAnios" id="perFinalAnios" value={perFinalAnios} onChange={handleInputChange}>
                <option value="">--Seleccionar--</option>
                  {periodOptions.map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="perFinalFechaIni">Del</Label>
                <Input type="date" name="perFinalFechaIni" id="perFinalFechaIni" value={perFinalFechaIni} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col className="col-4">
              <FormGroup>
                <Label for="perFinalFechaFin">al</Label>
                <Input type="date" name="perFinalFechaFin" id="perFinalFechaFin" value={perFinalFechaFin} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col className="col-12">
              <Button color="primary" onClick={handleSubmit}>Guardar</Button>{' '}
            </Col>
          </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      
    </React.Fragment>
  );
};

export default ConfigPeriodo;
